import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";
import {
    ShippingProviderFactory,
    ShippingVehicleTypeFactory,
    ShippingVehicleTypeMapperParameter,
    ShippingProviderMapperParameter,
} from "@/v2/models/shipping-providers.js";
import { ShippingClassFactory, ShippingClassMapperParameter } from "@/v2/models/shipping_class.js";

export class ShippingZone extends DataObject {
    _type = "shipping_zone";

    id;
    name;
    country;
    description;
    zone_regions = {};
    shipping_methods = {};
    show_action_menu;
    bo_can_delete;
}

export class ShippingZoneRegion extends DataObject {
    _type = "shipping_zone_region";

    id;
    shipping_zone_id;
    type;
    state;
    area;
    postcode_from;
    postcode_to;
}

export class ShippingMethod extends DataObject {
    _type = "shipping_method";

    id;
    shipping_zone_id;
    sequence;
    name;
    shipping_cost;
    min_shipping_cost;
    shipping_class_no_cost;
    min_order_amount;
    max_order_amount;
    capacity_limit;
    type;
    status;
    remarks;
    availability;
    availability_interval;
    shipping_availability_id;
    time_increment;
    shipping_providers = {};
    shipping_class_rate = {};
    shipping_table_rate = {};
    bo_can_delete;
    show_action_menu;
    checked;
    shipping_classes;
    shipping_class_labels;
    min_table_rate;
    max_table_rate;
    table_rate_unit;
    calculation_mode;
    measured_by;
}

export class shippingMethodProvider extends DataObject {
    _type = "shipping_method_provider";

    id;
    shipping_method_id;
    shipping_provider_id;
    shipping_vehicle_type_id;
    min_order_percentage;
    shipping_provider = {};
    shipping_vehicle_type = {};
}

export class ShippingClassRate extends DataObject {
    _type = "shipping_class_rate";

    shipping_class_id;
    shipping_method_id;
    cost;
    shipping_class = {};
}

export class ShippingTableRate extends DataObject {
    _type = "shipping_table_rate";

    id;
    shipping_method_id;
    amount_from;
    amount_to;
    price;
    unit;
}

export class ShippingZoneMapperParameter extends Parameter {
    shippingZoneMapper;
    shippingZoneRegionMapperParameter = new ShippingZoneRegionMapperParameter();
    shippingMethodMapperParameter = new ShippingMethodMapperParameter();
}

export class ShippingZoneRegionMapperParameter extends Parameter {
    shippingZoneRegionMapper;
}

export class ShippingMethodMapperParameter extends Parameter {
    shippingMethodMapper;
    shippingProviderMapperParameter = new ShippingProviderMapperParameter();
    shippingClassRateMapperParameter = new ShippingClassRateMapperParameter();
    shippingTableRateMapperParameter = new ShippingTableRateMapperParameter();
}

export class ShippingMethodProviderMapperParameter extends Parameter {
    shippingMethodProviderMapper;
    shippingProviderMapperParameter = new ShippingProviderMapperParameter();
    shippingVehicleTypeMapperParameter = new ShippingVehicleTypeMapperParameter();
}

export class ShippingClassRateMapperParameter extends Parameter {
    shippingClassRateMapper;
    shippingClassMapperParameter = new ShippingClassMapperParameter();
}

export class ShippingTableRateMapperParameter extends Parameter {
    shippingTableRateMapper;
}

export class ShippingZoneFactory {
    static construct(shippingZoneMapperParameter, data = null) {
        if (data != null) {
            let model = DataObjectFactory.getInstance().construct(
                ShippingZone,
                data ? shippingZoneMapperParameter.shippingZoneMapper(data) : null
            );

            if (data.zone_regions != null) {
                let temp = {};
                data.zone_regions.forEach((tempData) => {
                    const data = ShippingZoneRegionFactory.construct(
                        shippingZoneMapperParameter.shippingZoneRegionMapperParameter,
                        tempData
                    );
                    temp[data.id] = data;
                });

                model.zone_regions = temp;
            }

            if (data.shipping_methods != null) {
                let temp = {};
                data.shipping_methods.forEach((tempData) => {
                    const data = ShippingMethodFactory.construct(
                        shippingZoneMapperParameter.shippingMethodMapperParameter,
                        tempData
                    );
                    temp[data.id] = data;
                });

                model.shipping_methods = temp;
            }

            return model;
        }

        return null;
    }
}

export class ShippingZoneRegionFactory {
    static construct(shippingZoneRegionMapperParameter, data = null) {
        if (data != null) {
            let shippingZoneRegion = DataObjectFactory.getInstance().construct(
                ShippingZoneRegion,
                data ? shippingZoneRegionMapperParameter.shippingZoneRegionMapper(data) : null
            );

            return shippingZoneRegion;
        }

        return null;
    }
}

export class ShippingMethodFactory {
    static construct(shippingMethodMapperParameter, data = null) {
        if (data != null) {
            let model = DataObjectFactory.getInstance().construct(
                ShippingMethod,
                data ? shippingMethodMapperParameter.shippingMethodMapper(data) : null
            );

            if (data.shipping_providers != null) {
                let temp = {};
                data.shipping_providers.forEach((tempData) => {
                    const data = ShippingProviderFactory.construct(
                        shippingMethodMapperParameter.shippingProviderMapperParameter,
                        tempData
                    );
                    temp[data.id] = data;
                });

                model.shipping_providers = temp;
            }

            // if (data.shipping_method_provider != null) {
            //     let temp = {};
            //     data.shipping_method_provider.forEach((tempData) => {
            //         const data = ShippingMethodProviderFactory.construct(
            //             shippingMethodMapperParameter.shippingMethodProviderMapperParameter,
            //             tempData
            //         );
            //         temp[data.id] = data;
            //     });

            //     model.shipping_method_provider = temp;
            // }

            if (data.shipping_class_rates != null) {
                let temp = {};
                data.shipping_class_rates.forEach((tempData) => {
                    const data = ShippingClassRateFactory.construct(
                        shippingMethodMapperParameter.shippingClassRateMapperParameter,
                        tempData
                    );
                    temp[data.shipping_class_id] = data;
                });

                model.shipping_class_rate = temp;
            }

            if (data.shipping_table_rates != null) {
                let temp = {};
                data.shipping_table_rates.forEach((tempData) => {
                    const data = ShippingTableRateFactory.construct(
                        shippingMethodMapperParameter.shippingTableRateMapperParameter,
                        tempData
                    );
                    temp[data.id] = data;
                });

                model.shipping_table_rate = temp;
            }

            return model;
        }

        return null;
    }
}

export class ShippingMethodProviderFactory {
    static construct(shippingMethodProviderMapperParameter, data = null) {
        if (data != null) {
            let model = DataObjectFactory.getInstance().construct(
                shippingMethodProvider,
                data ? shippingMethodProviderMapperParameter.shippingMethodProviderMapper(data) : null
            );

            if (data.shipping_provider != null) {
                model.shipping_provider = ShippingProviderFactory.construct(
                    shippingMethodProviderMapperParameter.shippingProviderMapperParameter,
                    data.shipping_provider
                );
            }

            if (data.shipping_vehicle_type != null) {
                model.shipping_vehicle_type = ShippingVehicleTypeFactory.construct(
                    shippingMethodProviderMapperParameter.shippingVehicleTypeMapperParameter,
                    data.shipping_vehicle_type
                );
            }

            return model;
        }

        return null;
    }
}

export class ShippingClassRateFactory {
    static construct(shippingClassRateMapperParameter, data = null) {
        if (data != null) {
            let model = DataObjectFactory.getInstance().construct(
                ShippingClassRate,
                data ? shippingClassRateMapperParameter.shippingClassRateMapper(data) : null
            );

            if (data.shipping_class != null) {
                let temp = {};
                data.shipping_class.forEach((tempData) => {
                    const data = ShippingClassFactory.construct(
                        shippingClassRateMapperParameter.shippingClassMapperParameter,
                        tempData
                    );
                    temp[data.id] = data;
                });

                model.shipping_class = temp;
            }

            return model;
        }

        return null;
    }
}

export class ShippingTableRateFactory {
    static construct(shippingTableRateMapperParameter, data = null) {
        if (data != null) {
            let shippingTableRate = DataObjectFactory.getInstance().construct(
                ShippingTableRate,
                data ? shippingTableRateMapperParameter.shippingTableRateMapper(data) : null
            );

            return shippingTableRate;
        }

        return null;
    }
}
